// mapper: {
// 	fromFieldName: toFieldName,
// }
const mapFields = (data, mapper) => {
	const result = {}
	Object.entries(mapper).forEach(([field, newField]) => {
		if(newField && data.hasOwnProperty(field)){
			result[newField] = data[field];
		}
	});
	return result;
}

export default mapFields;